import { KanbanSquare, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Counts per follow-up stage, with a shortcut through to the board. */
export const PipelineSnapshot = ({ stats, onOpenBoard }) => (
  <div className="tt-card mt-4 p-5" data-testid="admin-pipeline-snapshot">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h2 className="tt-eyebrow">Follow-up pipeline</h2>
      <Button
        type="button"
        variant="outline"
        onClick={onOpenBoard}
        data-testid="admin-open-board-button"
        className="h-9 bg-white"
      >
        <KanbanSquare className="mr-2 h-4 w-4" aria-hidden="true" />
        Open the board
      </Button>
    </div>
    <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
      {stats.pipeline.map((stage) => (
        <div
          key={stage.status}
          data-testid={`admin-pipeline-${stage.status}`}
          className="rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-3 py-2.5"
        >
          <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-muted-foreground">
            {stage.label}
          </p>
          <p className="mt-1 font-amount text-xl font-bold leading-none text-foreground">
            {stage.count}
          </p>
        </div>
      ))}
    </div>
    {stats.email && !stats.email.configured ? (
      <p
        data-testid="admin-email-off-notice"
        className="mt-4 flex items-start gap-2 rounded-lg border px-4 py-3 text-[13px] leading-relaxed"
        style={{
          borderColor: "var(--tt-warn-border)",
          backgroundColor: "var(--tt-warn-bg)",
          color: "var(--tt-warn-text)",
        }}
      >
        <Mail className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <span>
          <strong className="font-bold">Quote emails are off.</strong> {stats.email.message}
        </span>
      </p>
    ) : null}
  </div>
);
